/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import * as S from "./styles";
import { useTimer } from "react-timer-hook";
export interface IStateOSDModalProps {
    open?: boolean;
}

export const STATE_OSD_MODAL_OPEN = "StateOSDModalVW:Open";
export const STATE_OSD_MODAL_CLOSE = "StateOSDModalVW:Close";
export const STATE_OSD_MODAL_TIMER_EXPIRY = "StateOSDModalVW:Expiry";

const MODAL_ITEMS = {
    open: false,
    currentID: null,
    title: null,
    image: null,
    width: null,
    height: null,
    description: null,
    expiry: null,
};

export const StateOSDModalVW = (props: IStateOSDModalProps) => {
    const eb = EventBusModule.getInstance().getEventBus();
    const [item, setItem] = useState(MODAL_ITEMS);
    const time = new Date();
    time.setSeconds(time.getSeconds() + 60);
    const onTimerExpiry = () => {
        eb.emit(STATE_OSD_MODAL_TIMER_EXPIRY, null, {});
        onModalClose();
    };
    const { seconds, minutes, hours, days, restart, isRunning, pause } =
        useTimer({
            expiryTimestamp: time,
            autoStart: false,
            onExpire: onTimerExpiry,
        });
    // debugger;

    useEffect(() => {
        _subscribe();
        return _unsubscribe;
    });

    const _subscribe = () => {
        eb.on(STATE_OSD_MODAL_OPEN, onModalOpen);
        eb.on(STATE_OSD_MODAL_CLOSE, onModalClose);
    };

    const _unsubscribe = () => {
        eb.off(STATE_OSD_MODAL_OPEN, onModalOpen);
        eb.off(STATE_OSD_MODAL_CLOSE, onModalClose);
    };

    const onModalOpen = (props: any) => {
        console.log(`in openModal item:`, props);
        if (item.open === false) {
            if (props.expiry) {
                const time = new Date();
                time.setSeconds(time.getSeconds() + props.expiry);
                restart(time);
            }
            setItem({
                open: true,
                ...{ ...(props || {}) },
            });
        }
    };

    const onModalClose = () => {
        if (item.open) {
            if (isRunning) {
                pause();
            }
            setItem({
                ...MODAL_ITEMS,
                open: false,
            });
        }
    };

    const _renderTitle = () => {
        if (item.title) {
            return <S.Title>{item.title}</S.Title>;
        }
    };

    const _renderImage = () => {
        if (item.image) {
            return (
                <S.Image
                    src={item.image}
                    width={item.width ?? "30%"}
                    height={item.height ?? "auto"}
                />
            );
        }
    };

    const _getTimerValue = () => {
        if (days) {
            return `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`;
        }
        if (hours) {
            return `${hours} hours, ${minutes} minutes, ${seconds} seconds`;
        }
        if (minutes) {
            return `${minutes} minutes, ${seconds} seconds`;
        }
        if (seconds) {
            return `${seconds} seconds`;
        }
    };

    const _renderDescription = () => {
        if (item.description) {
            return (
                <S.Description>
                    {item.description} {_getTimerValue()}
                </S.Description>
            );
        }
    };

    // const _renderTimer = () => {
    //     const _renderTimerValue = () => {
    //         if (days) {
    //             return (
    //                 <>
    //                     <S.Timer>{days} days, {hours} hours, {minutes} minutes, {seconds} seconds</S.Timer>
    //                 </>
    //             )
    //         }
    //         if (hours) {
    //             return (
    //                 <>
    //                     <S.Timer>{hours} hours, {minutes} minutes, {seconds} seconds</S.Timer>
    //                 </>
    //             )
    //         }
    //         if (minutes) {
    //             return (
    //                 <>
    //                     <S.Timer>{minutes} minutes, {seconds} seconds</S.Timer>
    //                 </>
    //             )
    //         }
    //         if (seconds) {
    //             return (
    //                 <>
    //                     <S.Timer>{seconds} seconds</S.Timer>
    //                 </>
    //             )
    //         }
    //     }
    //     let _comp = [];
    //     if (isRunning) {
    //         _comp.push(
    //             <div>
    //                 {_renderTimerValue()}
    //             </div>
    //         )
    //     }
    //     return _comp;
    // }

    const _renderBody = () => {
        return (
            <S.Container>
                {_renderTitle()}
                {_renderImage()}
                {_renderDescription()}
                {/* {_renderTimer()} */}
            </S.Container>
        );
    };

    const _getModal = () => {
        if (item?.open) {
            return (
                <Modal
                    isOpen={item?.open}
                    toggle={onModalClose}
                    fullwidth={true}
                    size={"lg"}
                    centered={true}
                    animation={false}
                    fade={false}
                    style={{ width: "100%" }}
                >
                    <ModalHeader toggle={onModalClose}></ModalHeader>
                    <ModalBody>{_renderBody()}</ModalBody>
                </Modal>
            );
        }
    };

    return <>{_getModal()} </>;
};
